export const CurrentSearch = {
    ADD_SEGMENT: 'ADD_SEGMENT_CURRENT_SEARCH',
    DELETE_SEGMENT: 'DELETE_SEGMENT_CURRENT_SEARCH',
    UPDATE_SEGMENT: 'UPDATE_SEGMENT_CURRENT_SEARCH',
    PERFORM_SEARCH: 'PERFORM_SEARCH_CURRENT_SEARCH',
    RESET_SEARCH: 'RESET_SEARCH',
    SET_ALL_SEARCH: 'SET_ALL_CURRENT_SEARCH',
    SET_CABIN_CLASS: 'SET_CABIN_CLASS_CURRENT_SEARCH',
    SET_ENTIRE_APARTMENT: 'SET_ENTIRE_APARTMENT_CURRENT_SEARCH',
    SET_CHAIN_FILTER: 'SET_CHAIN_FILTER',
    SET_HOTEL: 'SET_HOTEL_CURRENT_SEARCH',
    SET_ONLY_DIRECT_FLIGHTS: 'SET_ONLY_DIRECT_FLIGHTS_CURRENT_SEARCH',
    SET_AIRLINE_FILTER: 'SET_AIRLINE_FILTER_CURRENT_SEARCH',
    SET_PAX: 'SET_PAX_CURRENT_SEARCH',
    SET_RESIDENT_DISCOUNT: 'SET_RESIDENT_DISCOUNT_CURRENT_SEARCH',
    SET_TRIP_TYPE: 'SET_TRIP_TYPE_CURRENT_SEARCH',
    SET_HOTEL_TRIP_TYPE: 'SET_HOTEL_TRIP_TYPE_CURRENT_SEARCH',
    SET_SHOW_ERRORS: 'SET_SHOW_ERRORS_CURRENT_SEARCH',
    SET_SHOW_ROOM_ERRORS: 'SET_SHOW_ROOM_ERRORS_CURRENT_SEARCH',
    ADD_ROOM: 'ADD_ROOM_CURRENT_SEARCH',
    UPDATE_ROOM: 'UPDATE_ROOM_CURRENT_SEARCH',
    DELETE_ROOM: 'DELETE_ROOM_CURRENT_SEARCH',
    SET_SEPARATE_STAY: 'SET_SEPARATE_STAY_CURRENT_SEARCH',
    HANDLE_PRE_SEARCH: 'HANDLE_PRE_SEARCH',
    UPDATE_NON_PRIME_HOTEL_ROOM: 'UPDATE_NON_PRIME_HOTEL_ROOM',
    SET_NON_PRIME_HOTEL_SHOW_ERRORS: 'SET_NON_PRIME_HOTEL_SHOW_ERRORS',
    UPDATE_CONFIG: 'UPDATE_CONFIG',
};
